export default "/images/0963cf03e6b4ec6903145f3c5b0abf87.avif";